'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactCalendarPane = require('react-calendar-pane');

var _reactCalendarPane2 = _interopRequireDefault(_reactCalendarPane);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Calendar = function (_Component) {
  _inherits(Calendar, _Component);

  function Calendar(props) {
    _classCallCheck(this, Calendar);

    var _this = _possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call(this));

    _moment2.default.locale(props.locale);
    _this.ref = _this.ref.bind(_this);
    return _this;
  }

  _createClass(Calendar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.calendar.setState({ date: (0, _moment2.default)(nextProps.date) });
    }
  }, {
    key: 'previous',
    value: function previous() {
      this.calendar.previous();
    }
  }, {
    key: 'next',
    value: function next() {
      this.calendar.next();
    }
  }, {
    key: 'ref',
    value: function ref(element) {
      this.calendar = element;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          locale = _props.locale,
          date = _props.date,
          onSelect = _props.onSelect;


      return _react2.default.createElement(
        'div',
        { className: 'CalendarContainer' },
        _react2.default.createElement(
          'button',
          { className: 'previous', onClick: this.previous.bind(this), type: 'button' },
          _react2.default.createElement(_Icon2.default, { name: 'chevronLeft' })
        ),
        _react2.default.createElement(
          'button',
          { className: 'next', onClick: this.next.bind(this), type: 'button' },
          _react2.default.createElement(_Icon2.default, { name: 'chevronRight' })
        ),
        _react2.default.createElement(_reactCalendarPane2.default, {
          ref: this.ref,
          locale: locale,
          date: date,
          onSelect: onSelect,
          useNav: false
        })
      );
    }
  }]);

  return Calendar;
}(_react.Component);

Calendar.propTypes = {
  /** Moment object representing the selected date. */
  date: _propTypes2.default.instanceOf(_moment2.default),
  /** Function that is called when a date is selected. */
  onSelect: _propTypes2.default.func.isRequired,
  /** [Moment](https://momentjs.com/docs/#/i18n/) locale string */
  locale: _propTypes2.default.string
};
Calendar.defaultProps = {
  date: null,
  locale: _config2.default.config().locale
};
exports.default = Calendar;
Calendar.__docgenInfo = {
  'description': '',
  'methods': [{
    'name': 'previous',
    'docblock': null,
    'modifiers': [],
    'params': [],
    'returns': null
  }, {
    'name': 'next',
    'docblock': null,
    'modifiers': [],
    'params': [],
    'returns': null
  }, {
    'name': 'ref',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'element',
      'type': null
    }],
    'returns': null
  }],
  'displayName': 'Calendar',
  'props': {
    'date': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'instanceOf',
        'value': 'moment'
      },
      'required': false,
      'description': 'Moment object representing the selected date.'
    },
    'locale': {
      'defaultValue': {
        'value': 'CaligramReact.config().locale',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '[Moment](https://momentjs.com/docs/#/i18n/) locale string'
    },
    'onSelect': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': 'Function that is called when a date is selected.'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/Calendar.js
// module id = 606
// module chunks = 0